
export class UserSubscriptionPreferences {

  isEmailNotificationSelected?: boolean;
  isSmsNotificationSelected?: boolean;
}
